module.exports = __webpack_public_path__ + "static/media/key-message-stroke.38479961.svg";